import { render, staticRenderFns } from "./message-scheduler.vue?vue&type=template&id=ebbffe74&scoped=true"
import script from "./message-scheduler.vue?vue&type=script&lang=js"
export * from "./message-scheduler.vue?vue&type=script&lang=js"
import style0 from "./message-scheduler.vue?vue&type=style&index=0&id=ebbffe74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebbffe74",
  null
  
)

export default component.exports